import React from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from '@rbx/intl';
import { Tooltip, IconButton, FileCopyOutlinedIcon } from '@rbx/ui';
import { CurlCopyButtonTooltipData } from '../types';

interface CurlCopyButtonTooltipPortalProps {
  data: CurlCopyButtonTooltipData | null;
}

/**
 * Portal component for cURL copy button tooltip
 */
const CurlCopyButtonTooltipPortal = ({
  data,
}: CurlCopyButtonTooltipPortalProps): React.ReactElement | null => {
  const { translate } = useTranslation();
  if (!data) return null;

  return (
    <React.Fragment key='curl-copy-tooltip'>
      {createPortal(
        <Tooltip title={translate('Description.TryItOutCurlCopyWarning')}>
          <IconButton
            className={data.classes}
            onClick={data.clickHandler}
            aria-label={translate('Description.TryItOutCurlCopyWarning')}>
            <FileCopyOutlinedIcon />
          </IconButton>
        </Tooltip>,
        data.container,
      )}
    </React.Fragment>
  );
};

export default CurlCopyButtonTooltipPortal;
